module.exports = __webpack_public_path__ + "static/media/anage-atendimento.eea6be60.webp";